// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__1icgh","HeaderLogo":"Logo_HeaderLogo__3gM2W","footerLogo":"Logo_footerLogo__l3lHQ"};